module.exports = __webpack_public_path__ + "static/media/immediateFeature.c11b2584.png";